module.exports = __webpack_public_path__ + "wp-content/themes/clarks/img/now-you-see-me-intro.jpg";